<template>
  <div>
    {{ message }}
    <div v-if="showCancelButton || showConfirmButton" style="text-align: right; margin-top: 10px">
      <el-button v-if="showCancelButton" @click="onCancelClick">{{ cancelButtonText }}</el-button>
      <el-button v-if="showConfirmButton" type="primary" @click="onConfirmClick">{{ confirmButtonText }}</el-button>
    </div>
  </div>
</template>

<script>
  import i18n from '@/locale'
  export default {
    name: 'MgNotificationContent',
    props: {
      message: String,
      showCancelButton: {
        type: Boolean,
        default: false,
      },
      showConfirmButton: {
        type: Boolean,
        default: false,
      },
      cancelButtonText: {
        type: String,
        default: i18n.t('取消'),
      },
      confirmButtonText: {
        type: String,
        default: i18n.t('确定'),
      },
    },
    methods: {
      onCancelClick() {
        this.$emit('cancel', this.$parent)
      },
      onConfirmClick() {
        this.$emit('confirm', this.$parent)
      },
    },
  }
</script>
